import {useSelector} from 'react-redux';
import Selector from '../../../../../../../selectors/pages/home/tournaments';
import ModalsLib from '../../../../../../../lib/modals';
import BlueButton from '../../../../../../components/blue-button';
import {navigate} from '../../../../../../../utils/navigation';
import Timer from './timer';

export default () => {
    const {timestamp, isAuth} = useSelector(Selector);

    return (
        <div className="slide tournament summer size-params">
            <div className="size-params-layer layer0"><div className="grow1"></div></div>
            <div className="layer-margin size-params-layer layer0"><div className="grow2"></div></div>
            <div className="layer-margin size-params-layer layer0"><div className="grow3"></div></div>
            <div className="layer-margin size-params-layer layer0"><div className="grow4"></div></div>
            <div className="layer-margin size-params-layer layer0"><div className="girl"></div></div>
            <div className="layer-margin size-params slide-details"> 
                <div className="title">
                    SUMMER<br/>
                    TOURNAMENT
                </div>
                <div className="descriptions-short">
                    Stack your wins, rise through the leaderboard,<br/>
                    and compete for the $2,500 prize pool.
                </div>
                <div className="details">
                    <BlueButton onClick={e => {
                        navigate('/tournament');
                    }}>Participate</BlueButton>

                    <Timer timestamp={timestamp - Date.now()} />
                </div>
            </div>
        </div> 
    )
} 